var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon-bed_svg__filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    strokeWidth: 0,
    fill: "currentColor",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,45a1,1,0,0,0,2,0V44H11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39,45a1,1,0,0,0,2,0V44H39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.05,17H39a2,2,0,0,1-2,2H29a1.85,1.85,0,0,1-.48-.07l-.12,0a1.46,1.46,0,0,1-.36-.16l-.07,0a2.13,2.13,0,0,1-.69-.71h0A2,2,0,0,1,27,17H25a2,2,0,0,1-.28,1h0a2.13,2.13,0,0,1-.69.71l-.07,0a1.46,1.46,0,0,1-.36.16l-.12,0A1.85,1.85,0,0,1,23,19H15a2,2,0,0,1-2-2H9L4.25,33h43.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13,13a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2h2V13a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2h4V8.42A2.43,2.43,0,0,0,40.58,6H11.42A2.43,2.43,0,0,0,9,8.42V15h4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4,35v2.91A4,4,0,0,0,7.84,42H44.16A4,4,0,0,0,48,37.91V35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelBed);
export default __webpack_public_path__ + "static/media/hotelBed.8541078c82fe9ac6000fce847f749834.svg";
export { ForwardRef as ReactComponent };